import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconProfileCropped = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 25 25",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M7.811 8.719c-2.41 0-4.405-1.901-4.405-4.289C3.406 2.043 5.4.181 7.81.181s4.405 1.901 4.405 4.289c0 2.387-1.994 4.249-4.405 4.249h.001zm0-6.92c-1.497 0-2.743 1.174-2.743 2.67 0 1.497 1.205 2.67 2.741 2.67 1.538 0 2.743-1.173 2.743-2.67 0-1.496-1.247-2.67-2.742-2.67zm0 9.469c-2.494 0-4.82.97-6.026 2.59v-.001a.877.877 0 0 1-.666.324.812.812 0 0 1-.498-.162c-.374-.284-.457-.769-.166-1.133 1.538-1.983 4.362-3.237 7.396-3.237 2.992 0 5.775 1.174 7.272 3.155.25.365.208.85-.166 1.134-.375.242-.874.202-1.164-.162-1.205-1.537-3.49-2.508-5.984-2.508h.001z",
		clipRule: "evenodd"
	})
});
export default SvgIconProfileCropped;
